import { useState } from 'react';
import {
  TransformWrapper,
  TransformComponent,
  useControls,
} from 'react-zoom-pan-pinch';

import Icon from '../Icon';
import { IconButton } from '../Button';
import * as S from './style';

const ZoomControls = () => {
  const { zoomIn, zoomOut } = useControls();
  return (
    <S.Controls>
      <S.ControlButton
        type="button"
        aria-label="Zoom out"
        onClick={() => zoomOut()}
      >
        −
      </S.ControlButton>
      <S.Divider />
      <S.ControlButton
        type="button"
        aria-label="Zoom in"
        onClick={() => zoomIn()}
      >
        +
      </S.ControlButton>
    </S.Controls>
  );
};

const ZoomableImage = ({ src, alt, label = 'Zoom', children }) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!src) return children;

  return (
    <S.Container>
      {children}

      <S.ZoomTrigger>
        <S.TriggerButton
          type="button"
          onClick={() => setIsOpen(true)}
          aria-label="Zoom image"
        >
          <Icon icon="search" text={label} />
        </S.TriggerButton>
      </S.ZoomTrigger>

      <S.Modal
        open={isOpen}
        onClose={() => setIsOpen(false)}
        role="dialog"
        aria-label="Enlarged image"
      >
        <S.ModalInner>
          <S.Header>
            <IconButton handleClick={() => setIsOpen(false)} aria-label="Close">
              <Icon icon="close" text="Close" />
            </IconButton>
          </S.Header>

          <TransformWrapper
            centerOnInit
            minScale={1}
            maxScale={5}
            doubleClick={{ mode: 'zoomIn' }}
          >
            <ZoomControls />
            <S.ImageArea>
              <TransformComponent
                wrapperStyle={{ width: '100%', height: '100%' }}
                contentStyle={{ width: '100%', height: '100%' }}
              >
                <S.FullImage src={src} alt={alt} />
              </TransformComponent>
            </S.ImageArea>
          </TransformWrapper>
        </S.ModalInner>
      </S.Modal>
    </S.Container>
  );
};

export default ZoomableImage;
